import { CityPageQueryQuery } from '@medprev-web-app/api-graphql-client';

import { countTrueValues } from '@/utils/object.util';

export const getServiceChannelFlags = (cityConfig?: CityPageQueryQuery) => {
  if (!cityConfig) {
    return {
      businessId: undefined,
      serviceChannels: {},
      hasTelemedicine: false,
      hasAssistedPurchase: false,
      hasMedprevOnline: false,
      hasBranches: false,
      isNoOnlineWithBranch: false,
      isNoOnlineNoBranch: false,
      trueCount: 0,
      hasOneCta: false,
      noServiceType: false,
      onlyTelemedicineServiceChannel: false,
      isNoOnlineWithBranchAndTelemedicine: false,
      branches: [],
      branchesLength: 0,
      hasOneBranch: false,
      hasMoreThanOneBranch: false,
    };
  }

  const { businessModelByCity, branchesByCity } = cityConfig;

  const businessId = businessModelByCity?.businessID;

  const { ...serviceChannels } = businessModelByCity?.serviceChannels ?? {};

  delete serviceChannels['__typename'];

  const branches = (branchesByCity ?? []).filter(
    (branch): branch is NonNullable<typeof branch> => branch !== null && branch !== undefined,
  );
  const branchesLength = branches.length;
  const hasOneBranch = branchesLength === 1;
  const hasMoreThanOneBranch = branchesLength > 1;

  const hasMedprevOnline = Boolean(serviceChannels?.hasMedprevOnline);
  const hasAssistedPurchase = Boolean(serviceChannels?.hasAssistedPurchase);
  const hasBranches = Boolean(serviceChannels?.hasBranches) && !!branchesLength;
  const hasTelemedicine = Boolean(serviceChannels?.hasTelemedicine);

  const isNoOnlineWithBranch = !hasMedprevOnline && hasBranches;
  const isNoOnlineNoBranch = !hasMedprevOnline && !hasBranches;

  const trueCount = isNoOnlineNoBranch || isNoOnlineWithBranch
    ? countTrueValues(serviceChannels)
    : countTrueValues(serviceChannels, ['hasTelemedicine']);

  const hasOneCta = trueCount <= 1;
  const noServiceType = !hasMedprevOnline && !hasAssistedPurchase && !hasBranches && !hasTelemedicine;
  const onlyTelemedicineServiceChannel = !hasMedprevOnline && !hasAssistedPurchase && !hasBranches && hasTelemedicine;
  const isNoOnlineWithBranchAndTelemedicine = !hasMedprevOnline && hasBranches && hasTelemedicine;

  return {
    businessId,
    serviceChannels,
    hasTelemedicine,
    hasAssistedPurchase,
    hasMedprevOnline,
    hasBranches,
    isNoOnlineWithBranch,
    isNoOnlineNoBranch,
    trueCount,
    hasOneCta,
    noServiceType,
    onlyTelemedicineServiceChannel,
    isNoOnlineWithBranchAndTelemedicine,
    branches,
    branchesLength,
    hasOneBranch,
    hasMoreThanOneBranch,
  };
};
